import axiosInstance from 'api/axiosInstance'

export type GetMediaCategoriesParams = {
    search?: string
    sort_by?: 'name' | 'date_created' | 'posts' | 'premium'
    sort_order?: 'asc' | 'desc'
    post_id?: string
}

export const getMediaCategories = async (
    params: GetMediaCategoriesParams = {}
) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/media-categories',
        params: {
            search: params.search || undefined,
            sort_by: params.sort_by || undefined,
            sort_order: params.sort_order || undefined,
            post_id: params.post_id ?? undefined
        }
    })

    return data
}
export const getMediaCategoriesForSinglePost = async (id: number) => {
    const { data } = await axiosInstance({
        method: 'get',
        url: `/api/user/media-categories?post_id=${id}`
    })

    return data
}

export const createMediaCategories = async (
    name: string,
    isPublic: boolean,
    suggestions: boolean
  ) => {
    const { data } = await axiosInstance({
      method: 'POST',
      url: '/api/user/media-categories',
      data: {
        name,
        public: isPublic,
        suggestions: suggestions ? 1 : 0,
      }
    })
    return data
  }


export const editMediaCategories = async (name: string, id: any, isPublic: boolean) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/user/media-categories/${id}`,
        data: { name, public: isPublic ? 0 : 1 }
    })
    return data
}

export const deleteMediaCategory = async (id: any) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/user/media-categories/${id}`
    })
    return data
}
